import { enqueueSnackbar } from "notistack";
import { Component } from "react";
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    componentDidCatch(error, errorInfo) {
        // Log error to an error reporting service
        console.error("Error caught by ErrorBoundary:", error, errorInfo);
        enqueueSnackbar("Something went wrong, try again later", {
            variant: "ErrorMessage",
        });
        // You can also set a state to display an error message
        this.setState({ hasError: true });
    }
    render() {
        if (this.state.hasError) {
            // You can render a fallback UI here
            // return <h1>Something went wrong.</h1>;
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
